import React, { ReactNode, SyntheticEvent } from 'react';

import { Link, To } from 'react-router-dom';

import styles from './Button.module.scss';

export interface ButtonProps {
	id?: string;
	label?: string;
	color: 'blue' | 'green' | 'grey' | 'inactive' | 'white' | 'gradient';
	type?: 'submit' | 'reset' | 'button';
	disabled?: boolean;
	dense?: boolean;
	icon?: ReactNode;
	fullWidth?: boolean;
	onClick?: (e: SyntheticEvent) => void;
	endIcon?: React.ReactNode;
	to?: To;
	className?: string;
	target?: string;
	isLoading?: boolean;
}

export const AsaphButton = ({
	id,
	label,
	icon,
	disabled,
	type = 'button',
	dense = false,
	color = 'blue',
	isLoading = false,
	fullWidth,
	endIcon,
	to,
	target,
	className,
	onClick,
}: ButtonProps) => {
	const classes = [
		styles['btn'],
		color ? styles[`btn--${color}`] : undefined,
		dense ? styles['btn--dense'] : undefined,
		fullWidth ? styles['btn--full-width'] : undefined,
		isLoading ? styles['btn--loading'] : undefined,
		icon || isLoading ? styles['btn--has-icon'] : undefined,
		className,
	]
		.filter(Boolean)
		.join(' ');

	const content = (
		<>
			{(isLoading || icon) && (
				<span className={styles['btn__start-icon']}>
					{isLoading ? (
						<span className={styles['btn__spinner']} />
					) : (
						icon
					)}
				</span>
			)}
			{label}
			{endIcon && (
				<span className={styles['btn__end-icon']}>{endIcon}</span>
			)}
		</>
	);

	if (to !== undefined) {
		return (
			<Link to={to} target={target} className={classes} id={id}>
				{content}
			</Link>
		);
	}

	return (
		<button
			id={id}
			type={type || 'button'}
			disabled={disabled || isLoading}
			className={classes}
			onClick={onClick}
		>
			{content}
		</button>
	);
};
